import { FC } from 'react';
import { useField } from 'formik';

import ButtonDefault from 'shared/components/Buttons/ButtonsDefault';

import { OPPORTUNITY_BY_WHO_CREATED } from '@joc/api-gateway/lib/api-client';

import styles from './CreatedBy.module.scss';

const CreatedBy: FC<{ name: string; isSchool: boolean }> = ({ name, isSchool }) => {
	const [field, , helpers] = useField<Array<OPPORTUNITY_BY_WHO_CREATED>>(name);

	const toggleCreatedBy = (createdBy: OPPORTUNITY_BY_WHO_CREATED) => {
		const newCreatedBy = field.value.includes(createdBy)
			? field.value.filter(item => item !== createdBy)
			: [...field.value, createdBy];

		helpers.setValue(newCreatedBy).finally();
	};

	return (
		<section className={styles.createdBy}>
			<span className={styles.createdBy_label}>Created By:</span>
			<div className={styles.createdBy__list}>
				<ButtonDefault
					classList={[
						'secondary',
						field.value.includes(OPPORTUNITY_BY_WHO_CREATED.ORGANIZATION) ? 'secondary_active' : '',
					]}
					parentClassName={styles.createdBy__list_item}
					title="Organizations"
					clickHandler={() => toggleCreatedBy(OPPORTUNITY_BY_WHO_CREATED.ORGANIZATION)}
				/>
				<ButtonDefault
					classList={[
						'secondary',
						field.value.includes(OPPORTUNITY_BY_WHO_CREATED.VOLUNTEER) ? 'secondary_active' : '',
					]}
					parentClassName={styles.createdBy__list_item}
					title="Volunteers"
					clickHandler={() => toggleCreatedBy(OPPORTUNITY_BY_WHO_CREATED.VOLUNTEER)}
				/>
				<ButtonDefault
					classList={[
						'secondary',
						field.value.includes(OPPORTUNITY_BY_WHO_CREATED.VOLUNTEER_PRIVATE) ? 'secondary_active' : '',
					]}
					parentClassName={styles.createdBy__list_item}
					title="Private"
					clickHandler={() => toggleCreatedBy(OPPORTUNITY_BY_WHO_CREATED.VOLUNTEER_PRIVATE)}
				/>
			</div>
		</section>
	);
};

export default CreatedBy;
